import type { TypeQuote } from '@/types/commercial/types.commercial.quote';

export function quoteCode(quote: Pick<TypeQuote, 'number' | 'revision'>): string {
    if (!quote.number.seq) return 'senza numero';

    const base = `${quote.number.year}/${String(quote.number.seq).padStart(3, '0')}`;
    return quote.revision > 1 ? `${base} rev. ${quote.revision}` : base;
}
